module.exports = "<div #baChartistChart class=\"ba-chartist-chart {{baChartistChartClass || ''}}\"></div>\n<div class=\"col-md-6\" *ngFor=\"let item of gaugeCountArr; let i = index\" id={{item}} style=\"min-width: 310px; max-width: 400px; height: 317px; margin: 0 auto;\">\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baChartistChart/baChartistChart.html
// module id = ./src/app/theme/components/baChartistChart/baChartistChart.html
// module chunks = main